import { Location } from './location.model';

export interface CurrentUserResponse {
  idUser: string;
  username: string;
  email: string;
  nameUser: string;
  photoUser: string;
  photoUserUrl: string;
  lastNameUser: string;
  stateUser: string;
  idLocation: string;
  authorities: Authorities[];
  enabled: boolean;
  accountNonExpired: boolean;
  credentialsNonExpired: boolean;
  accountNonLocked: boolean;
}

export interface Authorities {
  authority: string;
}

export interface UserPagination {
  pageNumber: number;
  pageSize: number;
  totalPage: number;
  totalElements: number;
  content: UserResp[];
}

export interface Mozo {
  nameFull: string;
}


export interface UserNamesResp {
  useNamesFull: string[];
}

export interface User {
  idUser: string;
  idCompany: string;
  idLocation: string;
  username: string;
  password: string;
  useName: string;
  useLastName: string;
  useEmail: string;
  useState: string;
  roles: Role[];
}

export interface UserResp {
  idUser: string;
  idLocation: string;
  password: string;
  useName: string;
  useLastName: string;
  useEmail: string;
  useLocation: string;
  roles: Role[];
}

export interface UserCreate {
  idCompany: string;
  idLocation: string;
  password: string;
  useName: string;
  useLastName: string;
  useEmail: string;
  roles: string[];
}

export interface UserEditReq {
  idUser: string;
  idCompany: string;
  idLocation: string;
  password?: string;
  useName: string;
  useLastName: string;
  useEmail: string;
  roles: string[];
}

export interface Role {
  idRole: string;
  rolName: string;
}

export interface LocationParams {
  idCompany: string;
  idLocation: string;
}

export interface SignUp {
  idCompany: string;
  idLocation: string;
  password: string;
  useName: string;
  useLastName: string;
  useEmail: string;
  roles: string[];
}

export class UserModel {
  public listStates = [
    {
      name: 'Habilitado',
      value: 'Enabled',
    },
    {
      name: 'Deshabilitado',
      value: 'Disabled',
    },
  ];

  public pagination = {
    pageNumber: 0,
    pageSize: 40,
  };
}
